<template>
    <div id="userManger">
        <el-container>
            <el-header>
                <top-Nav></top-Nav>
            </el-header>
            <el-main>
              <div>
                        <div class="mainHead">
                            <div class="route">
                                <span class="crumbs"></span><span>用户管理</span>
                            </div>
                            <div class="search_warn_detail">
                                <div class="search" @mousemove="mousearch">
                                    <i></i>
                                    <el-input placeholder="搜索用户姓名、工号、账号、联系方式" v-model="searname" clearable @blur="searchBlur" @clear="clearableBack" ref="inputRef"></el-input>
                                </div>
                                <div class="screenBtn">
                                    <a @click="screenBtnShow = true">筛选</a>
                                    <div class="screenTip" v-show="screenBtnShow">
                                        <div class="screenHead">
                                            <div class="headTxt">筛选</div>
                                            <div class="headIcon" @click.stop="screenBtnShow = false"></div>
                                        </div>
                                        <div class="screenMain">
                                            <el-form :model="ruleFormOption" ref="ruleFormOption" class="demo-ruleForm">
                                                <el-form-item prop="roleStatusVal"> 
                                                    <div class="formHead">{{roleStatus.title}}</div>
                                                    <div class="formMain">
                                                        <el-checkbox-group v-model="ruleFormOption.roleStatusVal">
                                                            <el-checkbox-button v-for="(item,index) in roleStatus.option" :key="index" :label="item.value">{{item.name}}</el-checkbox-button>
                                                        </el-checkbox-group>
                                                    </div>
                                                </el-form-item>
                                                <el-form-item class="screenMainBtn">
                                                    <el-button @click="resetruleFormOption('ruleFormOption')">重置</el-button>
                                                    <el-button type="primary" @click="submitruleFormOption('ruleFormOption')">确定</el-button>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                    </div>
                                </div>
                                <el-button type="primary" @click="editUser()" v-if="isAuth('users:addUser')">新增用户</el-button>
                            </div>
                        </div>
                    </div>
              <div class="fixedScorll" :style="{height:basicHeight+'px'}">
                    <div class="tabs table_data" v-show="tableData.length>0">
                      <div class="surplus">剩余可用账户数：{{ableUserCount}}</div>
                      <el-table :data="tableData" style="width: 100%" border @row-click="searchUserInfo">
                        <el-table-column prop="index" label="序号" width="70"></el-table-column>
                        <el-table-column label="用户姓名" min-width="120">
                          <template slot-scope="scope">
                            <div class="has_user">
                              <el-tooltip class="item" effect="dark" :content="scope.row.userName" placement="top-start" :disabled="clientText>overflowText">
                                <span @mouseover="changeText($event)">{{scope.row.userName}}</span>
                              </el-tooltip>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="userNumber" label="用户工号" min-width="154"></el-table-column>
                        <el-table-column prop="loginName" label="用户账号" min-width="170"></el-table-column>
                        <el-table-column prop="userPhone" label="手机号" min-width="128"></el-table-column>
                        <el-table-column  label="微信昵称" min-width="118">
                          <template slot-scope="scope">
                            <div v-if="scope.row.nickname">{{scope.row.nickname}}</div>
                            <div v-else>--</div>
                          </template>
                        </el-table-column>
                        <el-table-column label="启用状态" min-width="91">
                          <template slot-scope="scope">
                            <div v-if="scope.row.enabled">禁用</div>
                            <div v-else>启用</div>
                          </template>
                        </el-table-column>
                        <el-table-column label="拥有角色" min-width="145">
                          <template slot-scope="scope">
                            <div v-if="scope.row.rolename" class="has_user">
                              <el-tooltip class="item" effect="dark" :content="scope.row.rolename" placement="top-start" :disabled="clientText>overflowText">
                                <span @mouseover="changeText($event)">{{scope.row.rolename}}</span>
                              </el-tooltip>
                            </div>
                            <div v-else>--</div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="createDate" label="创建时间" min-width="172"></el-table-column>
                        <el-table-column prop="modifyDate" label="最近修改时间" min-width="172"></el-table-column>
                        <el-table-column label="操作" width="172" fixed="right">
                          <template slot-scope="scope">
                            <div class="btn_table">
                              <span @click.stop="editUserInfo(scope.row)" v-if="isAuth('users:editUser')">编辑</span>
                              <span v-if="scope.row.userType!=1&&scope.row.userType!=0&&isAuth('users:deleUser')" class="delete_btn" @click.stop="deleteUserInfo(scope.row)">删除</span>
                              <span v-else class="delete_btn value_reset">--</span>
                              <span class="last_btn" @click.stop="resetUserInfo(scope.row)" v-if="isAuth('users:updateUserPass')">重置密码</span>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                      <div style="text-align: right;margin-top: 15px" v-if="useTotal>20">
                        <el-pagination  @current-change="handleCurrentChange1" :current-page.sync="currPage" :page-size="20" layout="prev, pager, next" :total=useTotal background></el-pagination>
                      </div>
                    </div>
                  <div class="No" v-show="tableData.length===0">
                    <img src="../../../static/img/Nodata.png">
                    <span>暂无数据</span>
                  </div>

                  </div>
            </el-main>
        </el-container>
    </div>
</template>
<script>
    import topNav from '../../components/TopNav.vue';
    import {ajaxFuncJson} from '@/api/ajax';
    export default {
        name: 'userManger',
        data() {
            return {
                msg: '用户管理',
                navListName: '',
                screenBtnShow: false,
                currPage: 1,    //当前页
                pageSize: 20,   //每页数量
                searname: '',   //搜索名
                ableUserCount:'',
                //筛选多选值
                ruleFormOption: { 
                    roleStatusVal:[]
                },
                //筛选-角色状态
                roleStatus: {
                    title:'用户状态:',
                    option:[{
                        name:'启用',
                        value:'0'
                    },{
                        name:'禁用',
                        value:'1'
                    }]
                },
                useTotal:0,
                tableData: [''],
                basicHeight:0,
                clientText:'',
                overflowText:'',
                target:0,
                windowResize:null,
            }
        },
        mounted() {
          if(this.isAuth('common:interface')){
            this.getUserList();
          }
          this.listenKeyDown();
          let that = this;
          that.windowResize=function () {
            that.basicHeight=$('body').height()-$('.mainHead').outerHeight(true)-71;
            that.isScroll();
          };
          that.windowResize();
          window.addEventListener('resize',that.windowResize);
        },
        methods: {
          changeText(e){ //文字显示...
            this.overflowText = $(e.toElement)[0].offsetWidth;
            this.clientText=$(e.toElement)[0].parentNode.clientWidth;
          },
          isScroll(){
            this.$nextTick(()=>{
              let sHeight=document.getElementsByClassName('fixedScorll')[0].scrollHeight,
                cHeight=document.getElementsByClassName('fixedScorll')[0].clientHeight;
              if(sHeight>cHeight){
                document.getElementsByClassName('fixedScorll')[0].style.marginRight='3px';
              }else {
                document.getElementsByClassName('fixedScorll')[0].style.marginRight='20px';
              }
            });
          },
            // 获取用户列表
            getUserList() {
                let parms = {
                    currPage: this.currPage,
                    pageSize: this.pageSize,
                    searname: this.searname,
                    enables: this.ruleFormOption.roleStatusVal.join(','),
                };
                ajaxFuncJson('/users/list',parms).then(res=>{
                    if(res.data.status == 200){
                        this.tableData=res.data.data.rows;
                        if(this.tableData.length>0){
                          this.ableUserCount=this.tableData[0].usecount;
                        }
                        this.tableData.forEach((a,b)=>{
                          this.$set(a,'index',20*(this.currPage-1)+(b+1));
                          if(a.rolename.length>0){
                            let roleArray=[];
                            a.rolename.forEach((name,index)=>{
                              roleArray.push(name.name);
                            });
                            this.tableData[b].rolename=roleArray.join(';');
                          }else {
                            this.tableData[b].rolename=a.rolename.join(';');
                          }
                        });
                        this.useTotal=res.data.data.total;
                        this.isScroll();
                    }
                });
            },
          //监听enter键
          listenKeyDown(){
            let _this=this;
            document.onkeydown=function(event){
              var e = event || window.event || arguments.callee.caller.arguments[0];
              if(e && e.keyCode==13){//上,左
                _this.currPage=1;
                _this.getUserList();
              }
            };
          },
          mousearch(event){
            if(event.target.className == "el-input__icon el-icon-circle-close el-input__clear"){
              this.target = 1;
            }else{
              this.target = 0
            }
          },
          searchBlur(){
            if(this.target==1){
              this.searname = '';
              this.$refs.inputRef.$el.children[0].focus();
              this.target = 0
            }else {
              this.currPage=1;
              this.getUserList();
            }
          },
          searchUserInfo(row){
              this.$router.push({path:'/searchUserInfo',query:{id:row.id}});
          },
          deleteUserInfo(item){
            this.$confirm('确定删除'+item.userName+'用户？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal:false,
              closeOnPressEscape:false,
            }).then(() => {
              this.deleteUserInfoAjax(item);
            }).catch(() => {

            });
          },
          deleteUserInfoAjax(item){
            let params={
                id:item.id,
            };
            ajaxFuncJson('/users/deleUser',params).then(res=>{
                if(res.data.status==200){
                  this.$alert('删除成功', '提示', {
                    confirmButtonText: '我知道了',
                    callback: action => {
                      if(this.tableData.length===1){
                        if(this.currPage>1){
                          this.currPage=this.currPage-1;
                        }
                      }
                      this.getUserList();
                    }
                  });
                }else {
                  this.$message({
                    message: res.data.msg,
                    type:'error',
                  })
                }
            });
          },
          editUserInfo(item){
              if(item.userType!=0&&item.userType!=1){
                this.$router.push({path:'/editUser',query:{id:item.id,type:'edit'}});
              }else {
                this.$router.push({path:'/editUser',query:{id:item.id,type:'edit',runStatus:'0'}});
              }
          },
          //重置密码
          resetUserInfo(item){
            this.$confirm('确定重置'+item.userName+'的密码？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal:false,
              closeOnPressEscape:false,
            }).then(() => {
                this.resetUserInfoAjax(item);
            }).catch(() => {

            });
          },
          resetUserInfoAjax(item){
              let params={
                id:item.id
              };
              ajaxFuncJson('/users/updateUserPass',params).then(res=>{
                if(res.data.status==200){
                  this.$alert('重置成功', '提示', {
                    confirmButtonText: '我知道了',
                    callback: action => {
                      this.getUserList();
                    }
                  });
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error'
                  })
                }
              });
          },
            //分页按钮
            handleCurrentChange1(val){
                this.getUserList();
            },
          clearableBack(){ //清除回调
            this.$refs.inputRef.$el.children[0].focus();
          },
            // 筛选确定按钮
            submitruleFormOption(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.currPage=1;
                        this.getUserList();
                        this.screenBtnShow = false;
                    } else {
                        return false;
                    }
                });
            },
            // 筛选重置按钮
            resetruleFormOption(formName) {
                this.$refs[formName].resetFields();
                this.currPage=1;
                this.getUserList();
            },
            // 新增用户按钮
            editUser() {
                if(parseInt(this.ableUserCount.split('/')[0])>0){
                  this.$router.push({path:'/editUser',query:{type:'add'}})
                }else {
                  this.$alert('当前可用账户无剩余，请删除部分无用账户或联系系统管理员！', '提示', {
                    confirmButtonText: '我知道了',
                    callback: action => {

                    }
                  });
                }
            },
        },
        destroyed(){
          let _this=this;
          window.removeEventListener("resize",_this.windowResize)
        },
        components: {
            topNav,
        }
    }
</script>
<style lang="scss" scope>
    @import "@/assets/css/mixin.scss";
    #userManger {
        height: 100%;
        .el-container {
            height: 100%;
            .el-main {
                width: 100% !important;
                height: 100% !important;
                margin: 0 !important;
                background: #f2f2f2;
                  .mainHead{
                    margin: 10px 20px 0 20px;
                  }
            }
        }

      .fixedScorll{
        background: #fff;
        margin-left: 20px;
        margin-right: 20px;
        .has_user{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap
        }
    }
      .mainHead {
          .search {
              position: relative;
              float: left;
              >i {
                  position: absolute;
                  top: 8px;
                  left: 10px;
                  @include wh(16px,16px);
                  @include bgImg('../../assets/img/search2.png');
                  cursor: pointer;
                  z-index: 1;
              }
              .el-input__inner {
                  padding-left: 36px !important;
              }
          }
          .screenBtn{
              position: relative;
              float: left;
              a {
                  float: right;
                  width: 48px;
                  margin: 0 20px;
                  padding-right: 20px;
                  box-shadow: 1px 0 0 #e0e0e0;
                  font-weight: normal;
              }
              .screenTip {
                  position: absolute;
                  right: 38px;
                  top: 28px;
                  z-index: 1000;
                  width: 340px;
                  min-height: 345px;
                  border: 1px solid #d1e8ff;
                  -webkit-box-shadow: 0 0 4px #198cff;
                  -moz-box-shadow: 0 0 4px #198cff;
                  box-shadow: 0 0 4px #198cff;
                  background-color: #fff;
                  .screenHead {
                      .headTxt {
                          margin-left: 20px;
                          font-size: $fontSizeFive;
                          color: $TxteAllcolor;
                          font-weight: bold;
                      }
                      .headIcon {
                          display: inline-block;
                          width: 42px;
                          height: 42px;
                          @include bgImg('../../assets/img/close.png');
                          &:hover {
                              @include bgImg('../../assets/img/closeClick.png');
                          }
                      }
                  }
                  .screenMain {
                      padding: 0 20px;
                      &.el-form {
                          min-height: 241px;
                          position: relative;
                          .formHead {
                              font-size: $fontSizeTwo;
                              color: #999999;
                          }
                          .screenMainBtn {
                              position: absolute;
                              right: 0;
                              bottom: -60px;
                          }
                      }
                  }
              }
          }
      }
      .btn_table{
        color: #198cff;
        span{
          cursor: pointer;
          padding-right: 10px;
        }
        .delete_btn{
          display: inline-block;
          width: 36px;
        }
        .value_reset{
          cursor: default;
          color: #282828;
        }
        .last_btn{
          padding-right: 0;
        }
      }
      .tabs {
          padding: 20px 20px 0;
          .surplus {
              float: right;
              margin-bottom: 10px;
              color: $TxteAllcolor;
              font-size: 13px;
          }
      }
    }
</style>



// WEBPACK FOOTER //
// src/page/systemManger/userManger.vue